// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/circuit-altitude-by-category.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/circuit-altitude-by-category/circuit-altitude-by-category.js';
import g1 from '../lessons/air-law/circuit-altitude-by-category/glider-circuit-operations.js';

mount([g0, g1]);
